import { render, staticRenderFns } from "./Objects.vue?vue&type=template&id=46fd4126&scoped=true"
import script from "./Objects.vue?vue&type=script&lang=js"
export * from "./Objects.vue?vue&type=script&lang=js"
import "./Objects.vue?vue&type=style&index=0&id=46fd4126&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fd4126",
  null
  
)

export default component.exports